import {Col, Row, Spinner} from "react-bootstrap";
import AdvancedCombobox from "../../primer/AdvancedCombobox";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Input from "../Input";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import axios from "axios";
import moment from "moment";
import {setExportTemplateName, setImportTemplateName} from "../../../_reducers/settingsSlice";
import useMediaQuery from "../../../hooks/useMediaQuery";
import {useTranslation} from "../../../hooks/useTranslation";

const ReportsTemplate = ({templateType, requestData, setRequestData, header, fetchReport, templateDisplayName}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const apiURL2 = process.env.REACT_APP_API_URL2;
    const [templateName, setTemplateName] = useState("");
    const [show, setShow] = useState(false);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [reFecthReport, setReFetchReport] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [templateOptions, setTemplateOptions] = useState([]);
    const templateColumns = [{label: t('SaveAsTemplateIndex.placeholder'), name: "name"}];
    const isMobileScreen = useMediaQuery("(max-width: 980px)");
    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);

    useEffect(() => {
        if (reFecthReport) {
            fetchReport();
            setReFetchReport(false);
        }
    }, [reFecthReport]);

    const handleClick = () => {
        setLoading(true);
        let postRequestData = structuredClone(requestData);
        if (templateType.includes("import") || templateType.includes("export")) {
            const tempData = postRequestData.filter((field) => field.checkBox === true);
            postRequestData = tempData.map(({ tooltip, ...rest }) => rest);
        }
        delete postRequestData?.page;
        let postTemplateData = {
            company: company.id,
            name: templateName,
            type: templateType,
            isActive: "active",
            templateData: JSON.stringify(postRequestData)
        }
        if (templateName && templateName !== '') {
            if (postTemplateData && Object.keys(postTemplateData).length > 0) {
                postTemplateFromReport(postTemplateData, clearStates);
            } else {
                setLoading(false);
                toast.error("Template data not found.");
            }
        } else {
            setLoading(false);
            toast.error("Template name is mandatory field.");
        }
    }

    const clearStates = () => {
        setTemplateName("");
        setLoading(false);
        handleClose();
    }

    const handleDeleteTemplate = (e, key, row) => {
        const deleteRequest = {id: row._id, isActive: "delete"}
        axios.put(apiURL2 + `/category/update-product-template`, deleteRequest, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                toast.success("Template deleted.");
                fetchTemplates();
            } else {
                toast.error(res.data.error);
            }
        }).catch((error) => {
            toast.error(error + " Update Template");
        })
    }

    const postTemplateFromReport = (data, clearStates) => {
        axios.post(apiURL2 + `/category/add-product-template`, data, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                toast.success("New template added.");
                fetchTemplates();
                clearStates();
            } else {
                toast.error(res.data.error);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data.errors) {
                toast.error(error.response.data.errors);
            } else {
                console.log("Unable to add template.");
            }
        })
    }

    const fetchTemplates = () => {
        const data = {company: company.id, type: templateType};
        axios.post(apiURL2 + `/category/list-product-template`, data, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                setTemplateOptions(res.data.data);
            } else {
                toast.error(res.data.errors);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    useEffect(() => {
        fetchTemplates();
    }, [templateType]);

    const handleTemplateChange = (e) => {
        if (String(e?.row?.type).startsWith("import_")) {
            if (e?.row?.templateData) {
                dispatch(setImportTemplateName(e?.row?.name));
            } else {
                toast.error("Unable to apply template.");
            }
        } else if (String(e.row?.type).startsWith("export_")) {
            if (e?.row?.templateData) {
                dispatch(setExportTemplateName(e?.row?.name));
            } else {
                toast.error("Unable to apply template.");
            }
        }
        if (e?.row?.templateData) {
            let selectedTemplateData = JSON.parse(e.row.templateData);
            const dateFields = ['date_from', 'date_to', 'startDateFrom', 'startDateTo', 'activationDateFrom', 'activationDateTo', 'dateFrom', 'dateTo', 'paymentDateFrom', 'paymentDateTo'];
            const dateFormat = "DD/MM/YYYY";
            const updatedYear = Number(company.year);
            dateFields.forEach((field) => {
                const dateStr = selectedTemplateData?.[field];
                if (dateStr && moment(dateStr, dateFormat).isValid()) {
                    const originalDate = moment(dateStr, dateFormat);
                    const updatedDate = originalDate.clone().year(updatedYear);
                    const format = originalDate.creationData().format || dateFormat;
                    selectedTemplateData[field] = updatedDate.format(format);
                }
            });
            if (selectedTemplateData?.month && moment(selectedTemplateData.month).isValid() && !["ai-module"].includes(templateType)) {
                const originalDate = moment(selectedTemplateData.month);
                const updatedDate = originalDate.clone().year(updatedYear);
                selectedTemplateData.month = updatedDate.toDate();
            }
            selectedTemplateData.templateName = e.row?.name;
            setRequestData(selectedTemplateData);
            setReFetchReport(true);
        } else {
            toast.error("Unable to apply template.");
        }
    }

    const handleClearTemplate = () => {
        if (Array.isArray(requestData)) {
            setRequestData([...requestData.slice(0, -1), { templateName: ""}]);
        } else if (typeof requestData === "object") {
            setRequestData({...requestData, templateName: ""});
        }
        dispatch(setImportTemplateName(""));
        dispatch(setExportTemplateName(""));
    }

    return (
        <div className="template-header-ui template-select border-bottom pb-1 mb-3" style={{...slideBarToggle ? {} : {padding: "5px 20px 5px 74px !important"}}}>
            <Row>
                <Col xs="11" md="3">
                    <div className="inline-select-ui-4 template-dropdown">
                        <AdvancedCombobox
                            className="w-100 ac-select-dropdown"
                            defaultValue={templateDisplayName || requestData?.templateName || ""}
                            key={Math.random()}
                            label={t('DataPanelIndex.template.template')}
                            data={templateOptions}
                            onChange={(e) => handleTemplateChange(e)}
                            excludeColumns={[]}
                            columns={templateColumns}
                            deleteEnable={true}
                            searchTableEnable={false}
                            showTableOptionOnSelect={true}
                            placeholder={t('DataPanelIndex.template.placeholder')}
                            onDelete={handleDeleteTemplate}
                        />
                    </div>
                </Col>
                <Col xs="1" md="1">
                    <div className="d-flex">
                        <div>
                            {((templateDisplayName && templateDisplayName.length > 0) || (requestData.templateName && requestData.templateName.length > 0))
                                && (<button className="btn quick-retail-clientbtn btn-default btn-sm" title="De-select Template" onClick={() => handleClearTemplate()}><i className="fas fa-xmark"></i></button>)
                            }
                        </div>
                    </div>
                </Col>
                <Col className="text-center justify-content-center align-items-center d-flex" xs="12" md="4" xxl="6">
                    {<b className="heading">{header}</b>}
                </Col>
                <Col xs="12" md="4" className=" justify-content-end align-items-center d-flex">
                    <React.Fragment>
                        <Button backdrop={"static"} size="sm"
                                onClick={() => handleShow()}>{t('SaveAsTemplateIndex.saveAsTemplate')}</Button>
                        <Modal backdrop={"static"} className="themeModal" show={show} onHide={() => handleClose()}>
                            <Modal.Header closeButton style={{fontSize: "16px", textAlign: "center"}}>
                                Εισαγωγή νέου προτύπου
                            </Modal.Header>
                            <Modal.Body>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <Input
                                        name={"newTemplateName"}
                                        label={t('SaveAsTemplateIndex.nameOfNewTemplate')}
                                        placeholder={t('SaveAsTemplateIndex.placeholder')}
                                        value={templateName}
                                        required={true}
                                        autoComplete={"off"}
                                        onChange={(e) => setTemplateName(e.target.value)}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="modal-actions">
                                    <Button variant="outline-primary" onClick={() => handleClose()} disabled={loading}
                                            className="mr-2">{t('SaveAsTemplateIndex.cancel')}</Button>
                                    <Button variant="primary" onClick={() => handleClick()} disabled={loading}>
                                        {t('SaveAsTemplateIndex.save')} {loading &&
                                        <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                                    </Button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                    </React.Fragment>
                </Col>
            </Row>
        </div>
    )
}

export default ReportsTemplate;
